module.exports = __webpack_public_path__ + "img/landing-frame-04.2e3e3310.png";